/**
 * Asset type options
 */
export type AssetType = 'sponsored' | 'unsponsored';

/**
 * Validation parameters interface
 */
export interface ValidationParams {
  peDemandSub?: boolean;
  [key: string]: any; // Allow for other properties
}

/**
 * Determines asset type based on peDemandSub parameter
 * 
 * @param peDemandSub - Boolean indicating if the asset is PE demand subscription
 * @returns 'sponsored' if peDemandSub is true, otherwise 'unsponsored'
 */
export function getAssetType(peDemandSub?: boolean): AssetType {
  return peDemandSub ? 'sponsored' : 'unsponsored';
}

/**
 * Determines asset type from validation parameters object
 * 
 * @param validationParams - Object containing validation parameters
 * @returns 'sponsored' if peDemandSub is true, otherwise 'unsponsored'
 */
export function getAssetTypeFromParams(validationParams?: ValidationParams): AssetType {
  return getAssetType(validationParams?.peDemandSub);
}

/**
 * Checks if asset is sponsored based on peDemandSub parameter
 * 
 * @param peDemandSub - Boolean indicating if the asset is PE demand subscription
 * @returns true if asset is sponsored, false otherwise
 */
export function isSponsored(peDemandSub?: boolean): boolean {
  return !!peDemandSub;
}

/**
 * Checks if asset is sponsored from validation parameters object
 * 
 * @param validationParams - Object containing validation parameters
 * @returns true if asset is sponsored, false otherwise
 */
export function isSponsoredFromParams(validationParams?: ValidationParams): boolean {
  return isSponsored(validationParams?.peDemandSub);
}

export default getAssetTypeFromParams;